/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_TitleInputs */

const en_cv_check_title = /** @type {(inputs: Cv_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV Check`)
};

const de_cv_check_title = /** @type {(inputs: Cv_Check_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf-Check`)
};

/**
* | output |
* | --- |
* | "CV Check" |
*
* @param {Cv_Check_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_title = /** @type {((inputs?: Cv_Check_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_title(inputs)
	return en_cv_check_title(inputs)
});